<template>
  <div
    v-if="isOpen && customValuesList.length"
    id="task_custom_column_preview"
    :class="[$style.task_resources_preview_popup, 'gantt_scroll']"
    :style="{ width: '200px', maxHeight: '336px' }"
  >
    <div :class="$style.task_resources_list">
      <div
        v-for="item in preparedCustomValues"
        :key="item.id"
        :class="$style.task_resource_item"
      >
        <div
          v-if="item.isDivider"
          :class="$style.divider_item_container"
        >
          <span :class="$style.divider_caption">
            {{ locales(item.label) }}
          </span>

          <span :class="$style.divider_underline" />
        </div>

        <div
          v-else-if="item.color"
          :class="$style.resource_item_container"
        >
          <div :class="$style.info_box">
            <div
              :class="$style.resource_item_color"
              :style="{ background: item.color }"
            />
            <div :class="$style.resource_item_info">
              {{ formatName(item.value) }}
            </div>
          </div>
        </div>

        <div
          v-else-if="item.picture"
          :class="$style.resource_item_container"
        >
          <div :class="$style.info_box">
            <vgp-avatar
              :class="$style.resource_item_icon"
              :src="item.picture"
              custom-size="22"
            />

            <div :class="$style.resource_item_info">
              {{ formatName(item.name) }}
            </div>
          </div>
        </div>

        <div
          v-else
          :class="$style.resource_item_container"
        >
          <div :class="$style.info_box">
            <div :class="$style.resource_item_info">
              {{ formatName(item.value) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="['js_preview_popup_bottom_arrow', $style.preview_popup_bottom_arrow]" />
  </div>
</template>

<script>
import _ from 'lodash';
import app from '$$app';
import globalStore from '$$globalStore';
import vgpAvatar from '$$vueCmp/avatar/vgpAvatar.vue';
import constants from '$$helpers/constants';
import userCustomColumnsComponent from '../../components/userCustomColumns';

export default {
  name: 'TaskCustomColumnPreviewPopup',
  components: { vgpAvatar },
  data() {
    return {
      locales: __,
      isOpen: false,
      timer: null,
      eventsListeners: [],
      customValuesList: [],
      columnType: null,
    };
  },
  computed: {
    preparedCustomValues() {
      const customValuesList = this.customValuesList;
      const columnType = this.columnType;

      if (columnType === constants.CUSTOM_COLUMNS_TYPES.resources.id) {
        const groupedResources = _.groupBy(customValuesList, resource => (_.isNull(resource.userId) ? 'material' : 'people'));

        return [
          ...groupedResources.people ? [{ isDivider: true, label: 'resources_layout_header_title_1' }] : [],
          ...groupedResources.people || [],
          ...groupedResources.material ? [{ isDivider: true, label: 'resources_layout_header_title_2' }] : [],
          ...groupedResources.material || [],
        ];
      }

      return customValuesList;
    },
  },
  created() {
    this.addEventListeners();
  },
  beforeUnmount() {
    this.removeEventsListeners();
  },
  methods: {
    addEventListeners() {
      this.removeEventsListeners();

      this.eventsListeners.push(app.on('showCustomColumnPreviewList', this.showCustomColumnPreviewList.bind(this)));
      this.eventsListeners.push(app.on('hideCustomColumnPreviewList', this.hideCustomColumnPreviewList.bind(this)));
    },

    removeEventsListeners() {
      this.eventsListeners.forEach(id => app.off(id));
      this.eventsListeners = [];
    },

    showCustomColumnPreviewList(position, taskId, ganttId, columnId) {
      this.hideCustomColumnPreviewList();

      const component = this;

      this.timer = setTimeout(() => {
        const task = globalStore.getters['tasksModel/getTaskByGanttId'](ganttId, taskId);
        const column = globalStore.getters['columns/getCustomColumnById'](columnId);

        if (task.id && column) {
          const customColumnValue = userCustomColumnsComponent.getUserCustomValue(task, columnId);
          const textColumnPreview = !customColumnValue?.preview && customColumnValue?.value ? [{ id: columnId, value: customColumnValue?.value }] : null;

          component.customValuesList = customColumnValue?.preview || textColumnPreview || [];
          component.columnType = column.type;
        }

        component.isOpen = true;
        component.$nextTick(() => {
          component.customValuesList.length && component.calcPopupPosition(position);
        });
      }, 1000);
    },

    hideCustomColumnPreviewList() {
      clearTimeout(this.timer);

      this.isOpen = false;
    },

    calcPopupPosition(position) {
      const popup = document.querySelector('#task_custom_column_preview');
      const popupHeight = popup.clientHeight;
      const bottomArrow = popup.querySelector('.js_preview_popup_bottom_arrow');

      const top = position.top > popupHeight
        ? position.top - popupHeight - 3
        : position.top + position.height;

      popup.style.left = `${position.left}px`;
      popup.style.top = `${top}px`;

      if (bottomArrow) {
        bottomArrow.style.left = `${position.left + 13}px`;
        bottomArrow.style.top = `${top + popupHeight - (bottomArrow.clientHeight / 2)}px`;
      }
    },

    formatName(str) {
      return str.replace(/>/g, '&gt;').replace(/</g, '&lt;');
    },
  },
};
</script>

<style module src="../taskResourcesPopups/styles.less" lang="less"></style>
